export default __webpack_public_path__ + "static/media/cbbSala2.ac27d1d0.jpg";